import {CSSProperties} from 'react'

export const sharedRoot: CSSProperties = {
  fontFamily: 'Menlo, Monaco, "Courier New", monospace',
  fontFeatureSettings: '"liga" 0, "calt" 0',
  lineHeight: '1.5em',
  whiteSpace: 'pre',
  margin: 0,
}
